import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import InnerHTML from 'dangerously-set-html-content';
import { Elements } from '@stripe/react-stripe-js';
//properties
import { properties } from '../assets/properties';
//components
import ResponseStripeIframe from './ResponseStripeIframe';


function Response({ responsedata, errorMsg, redirectRef, stripePromise }) {
    const [isElementLoading, setIsElementLoading] = useState(true);

    const [clientSecret, setClientSecret] = useState("");
    const [captchaAction, setCaptchaAction] = useState("");
    const [template, setTemplate] = useState("");
    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [postCode, setPostCode] = useState("");
    const [country, setCountry] = useState("");
    const [returnUrl, setReturnUrl] = useState("");
    const [intentId, setIntentId] = useState("");
    const [region, setRegion] = useState("");
    const [currency, setCurrency] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [email, setEmail] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [phone, setPhone] = useState("");
    const [isFutureUsageSet, setFutureUsage] = useState(false);
    const [paypalClientToken, setPaypalClientToken] = useState("");
    const [intentType, setintentType] = useState("");
    const [amount, setAmount] = useState("");
    const [paypalCustomerId, setPaypalCustomerId] = useState("");
    const [stylesLoaded, setStylesLoaded] = useState(false);

    useEffect(() => {
        const { template, appShortName, clientSecret, addressLine1, addressLine2, postCode, country, returnUrl, intentId, region, currency, city, state, email, customerName, phone, setupFutureUsage, amount, paypalClientToken, intentType, paypalCustomerId } = responsedata || {};

        setClientSecret(clientSecret);
        setCaptchaAction(appShortName);
        setTemplate(template);
        setAddressLine1(addressLine1);
        setAddressLine2(addressLine2);
        setPostCode(postCode);
        setCountry(country);
        setReturnUrl(returnUrl);
        setIntentId(intentId);
        setRegion(region);
        setCurrency(currency);
        setCity(city);
        setState(state);
        setEmail(email);
        setCustomerName(customerName);
        setPhone(phone);
        setFutureUsage(setupFutureUsage);
        setAmount(amount);
        setPaypalClientToken(paypalClientToken);
        setintentType(intentType);
        setPaypalCustomerId(paypalCustomerId);
    }, [])

    // Inject <link> and <script> tags from template into <head> and wait for stylesheets to load
    useEffect(() => {
        if (!template) {
            setStylesLoaded(true);
            return;
        }
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = template;

        // Handle <link> tags
        const links = tempDiv.querySelectorAll('link[rel="stylesheet"], link[rel="preconnect"]');
        let stylesheetLinks = [];
        links.forEach(link => {
            const href = link.getAttribute('href');
            const rel = link.getAttribute('rel');
            if (href && rel && !document.head.querySelector(`link[rel='${rel}'][href='${href}']`)) {
                const newLink = document.createElement('link');
                Array.from(link.attributes).forEach(attr => {
                    newLink.setAttribute(attr.name, attr.value);
                });
                if (rel === 'stylesheet') {
                    stylesheetLinks.push(newLink);
                }
                document.head.appendChild(newLink);
            }
        });

        // Wait for all stylesheets to load
        if (stylesheetLinks.length === 0) {
            setStylesLoaded(true);
        } else {
            let loadedCount = 0;
            stylesheetLinks.forEach(link => {
                link.onload = () => {
                    loadedCount++;
                    if (loadedCount === stylesheetLinks.length) {
                        setStylesLoaded(true);
                    }
                };
                link.onerror = () => {
                    loadedCount++;
                    if (loadedCount === stylesheetLinks.length) {
                        setStylesLoaded(true);
                    }
                };
            });
        }

        // Handle <script> tags
        const scripts = tempDiv.querySelectorAll('script[src]');
        scripts.forEach(script => {
            const src = script.getAttribute('src');
            if (src && !document.head.querySelector(`script[src='${src}']`)) {
                const newScript = document.createElement('script');
                Array.from(script.attributes).forEach(attr => {
                    newScript.setAttribute(attr.name, attr.value);
                });
                // Optionally, copy inline script content if needed
                if (script.textContent) newScript.textContent = script.textContent;
                document.head.appendChild(newScript);
            }
        });

        // If no stylesheet links, setStylesLoaded immediately (for templates with only preconnect or no links)
        if (stylesheetLinks.length === 0) {
            setStylesLoaded(true);
        }

        // Cleanup: reset stylesLoaded on template change
        return () => setStylesLoaded(false);
    }, [template]);

    useEffect(() => {
        const options = {
            clientSecret,
            appearance: { theme: properties.theme },
            locale: "auto"
        };

        if (!errorMsg) {
            const targetElement = document.getElementById("wpg-iframe");
            if (targetElement) {
                const elementsProps = {
                    captchaAction: captchaAction,
                    addressLine1: addressLine1,
                    addressLine2: addressLine2,
                    postCode: postCode,
                    country: country,
                    returnUrl: returnUrl,
                    intentId: intentId,
                    region: region,
                    currency: currency,
                    city: city,
                    state: state,
                    email: email,
                    customerName: customerName,
                    phone: phone,
                    isFutureUsageSet: isFutureUsageSet,
                    paypalClientToken: paypalClientToken,
                    intentType: intentType,
                    amount: amount,
                    paypalCustomerId: paypalCustomerId,
                    setIsElementLoading: setIsElementLoading,
                    redirectReference: redirectRef // for enhanced redirect flow
                };
                clientSecret && ReactDOM.render(
                    <Elements stripe={stripePromise} options={options}>
                        {isElementLoading && <div id='loadingDiv'></div>}
                        <ResponseStripeIframe {...elementsProps} />
                    </Elements>,
                    targetElement)
            }
        }
    }, [template && clientSecret, isElementLoading]);

    // Remove <link> and <script> tags from template before rendering
    const getCleanTemplate = (rawTemplate) => {
        if (!rawTemplate) return '';
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = rawTemplate;
        // Remove all <link> and <script> tags
        tempDiv.querySelectorAll('link, script').forEach(el => el.remove());
        return tempDiv.innerHTML;
    };

    const cleanTemplate = getCleanTemplate(template);

    return (
        <div>
            {!errorMsg ? (
                !stylesLoaded ? (
                    <div className="spinner" id="spinner"></div> 
                ) : template ?
                    (<div><InnerHTML html={cleanTemplate} /></div>) : (<div id="wpg-iframe"></div>)
            ) : (<div className="errorMsg">{errorMsg}</div>)}
        </div>
    )
}

export default Response;